var _path, _path2, _path3, _ellipse, _path4, _path5, _ellipse2, _ellipse3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery1AlmostEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 270,
    viewBox: "0 0 269 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0264 116.936C65.0683 107.452 70.7582 89.576 85.7352 77.0088C100.712 64.4416 119.305 61.9423 127.263 71.4264L178.685 132.709C186.643 142.193 180.953 160.069 165.976 172.636C150.999 185.203 132.407 187.703 124.448 178.219L73.0264 116.936Z",
    fill: "#245F9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0642 116.301C61.6309 106.25 67.5747 87.3791 83.3399 74.1505C99.1052 60.9219 118.722 58.3454 127.155 68.3957L175.659 126.2C184.092 136.251 178.149 155.122 162.383 168.351C146.618 181.579 127.001 184.156 118.568 174.105L70.0642 116.301Z",
    fill: "#D5DBE9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.925 169.901C107.095 160.569 113.508 142.297 129.248 129.088C144.989 115.88 164.098 112.738 171.928 122.07L176.456 127.465C184.286 136.797 177.873 155.07 162.132 168.278C146.391 181.486 127.283 184.628 119.453 175.296L114.925 169.901Z",
    fill: "#E92A2A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 143.732,
    cy: 146.123,
    rx: 37.2635,
    ry: 21.9589,
    transform: "rotate(-40 143.732 146.123)",
    fill: "#FF4545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.973 116.107L129.874 122.064C128.017 123.622 125.186 122.968 124.201 120.754L118.175 107.201C117.119 104.827 113.557 105.694 113.71 108.288L115.974 146.676C116.153 149.717 119.721 151.254 122.055 149.296L129.154 143.339C131.01 141.782 133.842 142.436 134.826 144.65L140.853 158.202C141.909 160.576 145.47 159.71 145.317 157.116L143.054 118.727C142.874 115.687 139.306 114.149 136.973 116.107Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.972 116.108L131.42 120.767C133.43 130.02 130.371 140.049 122.613 146.558C121.132 147.801 119.552 148.852 117.907 149.716C119.161 150.392 120.788 150.359 122.053 149.298L129.152 143.341C131.009 141.783 133.84 142.437 134.825 144.651L140.852 158.203C141.907 160.577 145.469 159.711 145.316 157.117L143.052 118.729C142.873 115.688 139.305 114.151 136.972 116.108Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.4101,
    cy: 87.3444,
    rx: 33.5372,
    ry: 17.2218,
    transform: "rotate(-40 94.4101 87.3444)",
    fill: "#245F9B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.1305,
    cy: 79.8632,
    rx: 18.6318,
    ry: 9.31588,
    transform: "rotate(-40 88.1305 79.8632)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery1AlmostEmpty);
export default __webpack_public_path__ + "static/media/battery-1-almost-empty.ca35f182b6012e784b489cb12c562aac.svg";
export { ForwardRef as ReactComponent };